import { render, staticRenderFns } from "./User.vue?vue&type=template&id=ada6e5a6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/User.vue
// module id = 898
// module chunks = 0